<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>

  <div class="container">
    <div class="row" *ngIf="breedinfo">
      <div class="col-sm-12 col-md-6 col-lg-5 col-xl-5">
          <div class="single-post">
              <!-- Post Thumb -->
              <div class="post-thumb">
                  <img style="width:100%" src="https://passport.petcart.in/images/breedimages/{{breedinfo.image}}" alt="">
              </div>
              </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-7 col-xl-7" style="padding-left:10px">
   <div class="row">
  <div class="col-12">
 
  <h4>  <p style="font-style:open sans; color:#9b7544">{{breedinfo.name}}</p></h4>   
  </div> 
  <div class="col-12"  *ngIf="breedinfo.characteristics !== '...'">
  <h6><p style="font-style:open sans; color:#9b7544">Characteristics:</p></h6>
  <p style="font-style:open sans;  overflow-wrap:break-word " [innerHTML]="breedinfo.characteristics"></p>  
  </div>  
  </div> 
      </div>
    </div>
    <div class="row" *ngIf="breedinfo">
      <div class="12"  *ngIf="breedinfo.description !== '...'">
        <h4><p  style="font-style:open sans; color:#9b7544"><strong>Description</strong></p></h4>
        <p style="font-style:open sans; overflow-wrap:break-word " [innerHTML]="breedinfo.description"></p>  
      </div>
      <div class="12"  *ngIf="breedinfo.apperance !== '...'">
          <h4><p  style="font-style:open sans; color:#9b7544"><strong>Apperance</strong></p></h4>
          <p style="font-style:open sans;  overflow-wrap:break-word " [innerHTML]="breedinfo.apperance"></p>  
        </div>
        <div class="12"  *ngIf="breedinfo.head !== '...'">
            <h4><p  style="font-style:open sans; color:#9b7544"><strong>Head</strong></p></h4>
            <p style="font-style:open sans; overflow-wrap:break-word " [innerHTML]="breedinfo.head"></p>  
          </div>
          <div class="12"  *ngIf="breedinfo.body !== '...'">
              <h4><p  style="font-style:open sans; color:#9b7544"><strong>Body</strong></p></h4>
              <p style="font-style:open sans;  overflow-wrap:break-word " [innerHTML]="breedinfo.body"></p>  
            </div>
            <div class="12"  *ngIf="breedinfo.forequarter !== '...'">
                <h4><p  style="font-style:open sans; color:#9b7544"><strong>Forequarters</strong></p></h4>
                <p style="font-style:open sans; color:#9b7544; overflow-wrap:break-word " [innerHTML]="breedinfo.forequarters"></p>  
              </div>
              <div class="12"  *ngIf="breedinfo.coat !== '...'" >
                  <h4><p  style="font-style:open sans; color:#9b7544"><strong>Coat</strong></p></h4>
                  <p style="font-style:open sans;  overflow-wrap:break-word " [innerHTML]="breedinfo.coat"></p>  
                </div>
                <div class="12" *ngIf="breedinfo.hindquarter !== '...'">
                    <h4><p  style="font-style:open sans; color:#9b7544"><strong>Hindquarters</strong></p></h4>
                    <p style="font-style:open sans;  overflow-wrap:break-word " [innerHTML]="breedinfo.hindquarters"></p>  
                  </div>
                  <div class="12" *ngIf="breedinfo.expression !== '...'">
                      <h4><p  style="font-style:open sans; color:#9b7544"><strong>Expression</strong></p></h4>
                      <p style="font-style:open sans;  overflow-wrap:break-word " [innerHTML]="breedinfo.expression"></p>  
                    </div>
                    <div class="12" *ngIf="breedinfo.nutrition !== '...'">
                        <h4><p  style="font-style:open sans; color:#9b7544"><strong>Nutrition</strong></p></h4>
                        <p style="font-style:open sans;  overflow-wrap:break-word " [innerHTML]="breedinfo.nutrition"></p>  
                      </div>
                      <div class="12" *ngIf="breedinfo.grooming !== '...'">
                          <h4><p  style="font-style:open sans; color:#9b7544"><strong>Grooming</strong></p></h4>
                          <p style="font-style:open sans; overflow-wrap:break-word " [innerHTML]="breedinfo.grooming"></p>  
                        </div>
                        <div class="12" *ngIf="breedinfo.exercise !== '...'">
                            <h4><p  style="font-style:open sans; color:#9b7544"><strong>Exercise</strong></p></h4>
                            <p style="font-style:open sans; overflow-wrap:break-word " [innerHTML]="breedinfo.exercise"></p>  
                          </div>
                          <div class="12" *ngIf="breedinfo.health !== '...'">
                              <h4><p  style="font-style:open sans; color:#9b7544"><strong>Health</strong></p></h4>
                              <p style="font-style:open sans;  overflow-wrap:break-word " [innerHTML]="breedinfo.health"></p>  
                            </div>
    </div>
  </div>
<div >